import { Link, useParams } from "react-router-dom";
import { BriefingView } from "../components/BriefingView";
import { ChevronLeftIcon } from "../components/ui/icons";
import { ErrorState } from "../components/ui/ErrorState";
import { SkeletonScreen } from "../components/ui/Skeleton";
import { ApiRequestError } from "../api/client";
import { briefingDetail } from "../copy/sq";
import { useBriefingDetail } from "../hooks/useApi";

export function BriefingDetailScreen() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isError, error, refetch } = useBriefingDetail(id);

  return (
    <div>
      <Link to="/briefings" className="mb-4 inline-flex items-center gap-1 text-sm font-medium text-accent-600 hover:text-accent-700">
        <ChevronLeftIcon width={16} height={16} /> {briefingDetail.allBriefings}
      </Link>

      {isLoading ? (
        <SkeletonScreen cards={5} />
      ) : isError ? (
        <ErrorState
          title={error instanceof ApiRequestError && error.status === 404 ? briefingDetail.notFoundTitle : briefingDetail.loadErrorTitle}
          message={error instanceof Error ? error.message : undefined}
          onRetry={error instanceof ApiRequestError && error.status === 404 ? undefined : () => refetch()}
        />
      ) : data ? (
        <BriefingView briefing={data} />
      ) : null}
    </div>
  );
}
